import { render, staticRenderFns } from "./_Magistrant.vue?vue&type=template&id=658f1555"
import script from "./_Magistrant.vue?vue&type=script&lang=js"
export * from "./_Magistrant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports